import { createClient } from '@sanity/client';
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient();
export const sanityClient = createClient({
  projectId: 'ktaccrfv',
  dataset: 'production',
  perspective: 'published',
  apiVersion: 'v2025-02-16',
  useCdn: true,
});
